import { requestShapeFromAI } from '@/ai/chatGpt';

export const circleRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        circle.setAttribute('cx', centerX + Math.cos(angle * (Math.PI / 180)) * (habit.size + offset));
        circle.setAttribute('cy', centerY + Math.sin(angle * (Math.PI / 180)) * (habit.size + offset));
        circle.setAttribute('r', habit.size / 10);
        circle.setAttribute('fill', habit.color);
        container.appendChild(circle);
        
    }
};

export const squareRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const size = habit.size / 5;
        const x = centerX + Math.cos(angle * (Math.PI / 180)) * (habit.size + offset);
        const y = centerY + Math.sin(angle * (Math.PI / 180)) * (habit.size + offset);

        const square = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        square.setAttribute('x', x - size / 2);
        square.setAttribute('y', y - size / 2);
        square.setAttribute('width', size);
        square.setAttribute('height', size);
        square.setAttribute('fill', habit.color);
        container.appendChild(square);
    }
};

export const triangleRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const size = habit.size / 5;
        const x = centerX + Math.cos(angle * (Math.PI / 180)) * (habit.size + offset);
        const y = centerY + Math.sin(angle * (Math.PI / 180)) * (habit.size + offset);

        const points = [
            `${x},${y - size / 2}`,
            `${x - size / 2},${y + size / 2}`,
            `${x + size / 2},${y + size / 2}`,
        ];

        const triangle = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
        triangle.setAttribute('points', points.join(' '));
        triangle.setAttribute('fill', habit.color);
        container.appendChild(triangle);
    }
};

export const starRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const star = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
        const points = [];
        for (let j = 0; j < 5; j++) {
            const x = centerX + Math.cos((j * 144 + angle) * (Math.PI / 180)) * (habit.size + offset);
            const y = centerY + Math.sin((j * 144 + angle) * (Math.PI / 180)) * (habit.size + offset);
            points.push(`${x},${y}`);
        }
        star.setAttribute('points', points.join(' '));
        star.setAttribute('fill', 'none');
        star.setAttribute('stroke', habit.color);
        star.setAttribute('stroke-width', 2);

        container.appendChild(star);
    }
};

export const petalRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const petal = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        petal.setAttribute('d', `M ${centerX},${centerY - habit.size - offset}
            Q ${centerX + habit.size},${centerY}
            ${centerX},${centerY + habit.size + offset}
            Q ${centerX - habit.size},${centerY}
            ${centerX},${centerY - habit.size - offset} Z`);
        petal.setAttribute('fill', 'none');
        petal.setAttribute('stroke', habit.color);
        petal.setAttribute('stroke-width', 2);
        petal.setAttribute('transform', `rotate(${angle}, ${centerX}, ${centerY})`);
        container.appendChild(petal);
    }
};

export const hexagonRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const hexagon = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
        const x = centerX + Math.cos(angle * (Math.PI / 180)) * (habit.size + offset);
        const y = centerY + Math.sin(angle * (Math.PI / 180)) * (habit.size + offset);
        const side = habit.size / 10;
        const points = [];
        
        for (let j = 0; j < 6; j++) {
            const pointX = x + side * Math.cos((2 * Math.PI / 6) * j);
            const pointY = y + side * Math.sin((2 * Math.PI / 6) * j);
            points.push(`${pointX}, ${pointY}`);
        }
        
        hexagon.setAttribute('points', points.join(' '));
        hexagon.setAttribute('fill', habit.color);
        container.appendChild(hexagon);
    }
};

export const pentagonRenderer = (habit, centerX, centerY, offset, container) => {
    // for (let i = 0; i < habit.count; i++) {
    //     const angle = (360 / habit.count) * i;
    //     const pentagon = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
    //     let points = [];
    //     for (let j = 0; j < 5; j++) {
    //         const x = centerX + Math.cos((angle + j * 72) * (Math.PI / 180)) * (habit.size/20);
    //         const y = centerY + Math.sin((angle + j * 72) * (Math.PI / 180)) * (habit.size/20);
    //         points.push(`${x},${y}`);
    //     }
    //     pentagon.setAttribute('points', points.join(' '));
    //     pentagon.setAttribute('fill', habit.color);
    //     container.appendChild(pentagon);
    // }
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const size = habit.size / 20;  // Make the pentagons smaller by adjusting the divisor
        const x = centerX + Math.cos(angle * (Math.PI / 180)) * (habit.size + offset);
        const y = centerY + Math.sin(angle * (Math.PI / 180)) * (habit.size + offset);

        const pentagon = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
        let points = [];
        for (let j = 0; j < 5; j++) {
            const xPoint = x + size * Math.cos((angle + j * 72) * (Math.PI / 180));
            const yPoint = y + size * Math.sin((angle + j * 72) * (Math.PI / 180));
            points.push(`${xPoint},${yPoint}`);
        }

        pentagon.setAttribute('points', points.join(' '));
        pentagon.setAttribute('fill', habit.color);
        container.appendChild(pentagon);
    }
};

export const octagonRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const size = habit.size / 5;
        const x = centerX + Math.cos(angle * (Math.PI / 180)) * (habit.size + offset);
        const y = centerY + Math.sin(angle * (Math.PI / 180)) * (habit.size + offset);

        const octagon = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
        let points = [];
        for (let j = 0; j < 8; j++) {
            const pointX = x + size * Math.cos((j * 45) * (Math.PI / 180));
            const pointY = y + size * Math.sin((j * 45) * (Math.PI / 180));
            points.push(`${pointX},${pointY}`);
        }

        octagon.setAttribute('points', points.join(' '));
        octagon.setAttribute('fill', habit.color);
        container.appendChild(octagon);
    }
};

export const parallelogramRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const size = habit.size / 5;
        const x = centerX + Math.cos(angle * (Math.PI / 180)) * (habit.size + offset);
        const y = centerY + Math.sin(angle * (Math.PI / 180)) * (habit.size + offset);

        const parallelogram = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
        let points = [
            `${x - size / 2},${y - size / 4}`,
            `${x + size / 2},${y - size / 4}`,
            `${x + size / 4},${y + size / 4}`,
            `${x - size / 4},${y + size / 4}`
        ];

        parallelogram.setAttribute('points', points.join(' '));
        parallelogram.setAttribute('fill', habit.color);
        container.appendChild(parallelogram);
    }
};

export const crescentRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const outerRadius = habit.size / 3;
        const innerRadius = habit.size / 4;
        const x = centerX + Math.cos(angle * (Math.PI / 180)) * (habit.size + offset);
        const y = centerY + Math.sin(angle * (Math.PI / 180)) * (habit.size + offset);

        // Outer circle
        const outerCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        outerCircle.setAttribute('cx', x);
        outerCircle.setAttribute('cy', y);
        outerCircle.setAttribute('r', outerRadius);
        outerCircle.setAttribute('fill', habit.color);
        container.appendChild(outerCircle);

        // Inner circle (to create the crescent effect)
        const innerCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        innerCircle.setAttribute('cx', x + outerRadius / 2);
        innerCircle.setAttribute('cy', y);
        innerCircle.setAttribute('r', innerRadius);
        innerCircle.setAttribute('fill', '#ffffff'); // White or transparent
        container.appendChild(innerCircle);
    }
};

export const ellipseRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const rx = habit.size / 4;
        const ry = habit.size / 6;
        const x = centerX + Math.cos(angle * (Math.PI / 180)) * (habit.size + offset);
        const y = centerY + Math.sin(angle * (Math.PI / 180)) * (habit.size + offset);

        const ellipse = document.createElementNS('http://www.w3.org/2000/svg', 'ellipse');
        ellipse.setAttribute('cx', x);
        ellipse.setAttribute('cy', y);
        ellipse.setAttribute('rx', rx);
        ellipse.setAttribute('ry', ry);
        ellipse.setAttribute('fill', habit.color);
        container.appendChild(ellipse);
    }
};

export const rectangleRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const width = habit.size / 5;
        const height = habit.size / 8;
        const x = centerX + Math.cos(angle * (Math.PI / 180)) * (habit.size + offset);
        const y = centerY + Math.sin(angle * (Math.PI / 180)) * (habit.size + offset);

        const rectangle = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        rectangle.setAttribute('x', x - width / 2);
        rectangle.setAttribute('y', y - height / 2);
        rectangle.setAttribute('width', width);
        rectangle.setAttribute('height', height);
        rectangle.setAttribute('fill', habit.color);
        container.appendChild(rectangle);
    }
};

export const ovalRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const rx = habit.size / 4;
        const ry = habit.size / 6;
        const x = centerX + Math.cos(angle * (Math.PI / 180)) * (habit.size + offset);
        const y = centerY + Math.sin(angle * (Math.PI / 180)) * (habit.size + offset);

        const oval = document.createElementNS('http://www.w3.org/2000/svg', 'ellipse');
        oval.setAttribute('cx', x);
        oval.setAttribute('cy', y);
        oval.setAttribute('rx', rx);
        oval.setAttribute('ry', ry);
        oval.setAttribute('fill', habit.color);
        container.appendChild(oval);
    }
};

export const rhombusRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const size = habit.size / 5;
        const x = centerX + Math.cos(angle * (Math.PI / 180)) * (habit.size + offset);
        const y = centerY + Math.sin(angle * (Math.PI / 180)) * (habit.size + offset);

        const rhombus = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
        const points = [
            `${x},${y - size}`,
            `${x + size},${y}`,
            `${x},${y + size}`,
            `${x - size},${y}`
        ];
        
        rhombus.setAttribute('points', points.join(' '));
        rhombus.setAttribute('fill', habit.color);
        container.appendChild(rhombus);
    }
};

export const trapezoidRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const widthTop = habit.size / 3;
        const widthBottom = habit.size / 2;
        const height = habit.size / 4;
        const x = centerX + Math.cos(angle * (Math.PI / 180)) * (habit.size + offset);
        const y = centerY + Math.sin(angle * (Math.PI / 180)) * (habit.size + offset);

        const trapezoid = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
        const points = [
            `${x - widthTop / 2},${y - height}`,
            `${x + widthTop / 2},${y - height}`,
            `${x + widthBottom / 2},${y}`,
            `${x - widthBottom / 2},${y}`
        ];
        
        trapezoid.setAttribute('points', points.join(' '));
        trapezoid.setAttribute('fill', habit.color);
        container.appendChild(trapezoid);
    }
};

export const tetrahedronRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const size = habit.size / 4;
        const x = centerX + Math.cos(angle * (Math.PI / 180)) * (habit.size + offset);
        const y = centerY + Math.sin(angle * (Math.PI / 180)) * (habit.size + offset);

        const triangle = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
        const points = [
            `${x},${y - size}`,
            `${x - size},${y + size}`,
            `${x + size},${y + size}`
        ];

        triangle.setAttribute('points', points.join(' '));
        triangle.setAttribute('fill', habit.color);
        container.appendChild(triangle);
    }
};

export const pyramidRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const size = habit.size / 3;
        const x = centerX + Math.cos(angle * (Math.PI / 180)) * (habit.size + offset);
        const y = centerY + Math.sin(angle * (Math.PI / 180)) * (habit.size + offset);

        const pyramid = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
        const points = [
            `${x},${y - size}`,
            `${x - size},${y + size}`,
            `${x + size},${y + size}`
        ];

        pyramid.setAttribute('points', points.join(' '));
        pyramid.setAttribute('fill', habit.color);
        container.appendChild(pyramid);
    }
};

export const sphereRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const radius = habit.size / 5;
        const x = centerX + Math.cos(angle * (Math.PI / 180)) * (habit.size + offset);
        const y = centerY + Math.sin(angle * (Math.PI / 180)) * (habit.size + offset);

        const sphere = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        sphere.setAttribute('cx', x);
        sphere.setAttribute('cy', y);
        sphere.setAttribute('r', radius);
        sphere.setAttribute('fill', habit.color);
        container.appendChild(sphere);
    }
};

export const cubeRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const size = habit.size / 4;
        const x = centerX + Math.cos(angle * (Math.PI / 180)) * (habit.size + offset);
        const y = centerY + Math.sin(angle * (Math.PI / 180)) * (habit.size + offset);

        const square = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        square.setAttribute('x', x - size / 2);
        square.setAttribute('y', y - size / 2);
        square.setAttribute('width', size);
        square.setAttribute('height', size);
        square.setAttribute('fill', habit.color);
        container.appendChild(square);
    }
};

export const coneRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const size = habit.size / 3;
        const x = centerX + Math.cos(angle * (Math.PI / 180)) * (habit.size + offset);
        const y = centerY + Math.sin(angle * (Math.PI / 180)) * (habit.size + offset);

        const cone = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
        const points = [
            `${x},${y - size}`,
            `${x - size / 2},${y + size}`,
            `${x + size / 2},${y + size}`
        ];

        cone.setAttribute('points', points.join(' '));
        cone.setAttribute('fill', habit.color);
        container.appendChild(cone);
    }
};

export const cylinderRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const rx = habit.size / 4;
        const ry = habit.size / 8;
        const x = centerX + Math.cos(angle * (Math.PI / 180)) * (habit.size + offset);
        const y = centerY + Math.sin(angle * (Math.PI / 180)) * (habit.size + offset);

        const cylinder = document.createElementNS('http://www.w3.org/2000/svg', 'ellipse');
        cylinder.setAttribute('cx', x);
        cylinder.setAttribute('cy', y);
        cylinder.setAttribute('rx', rx);
        cylinder.setAttribute('ry', ry);
        cylinder.setAttribute('fill', habit.color);
        container.appendChild(cylinder);
    }
};

export const torusRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const outerRadius = habit.size / 3;
        const innerRadius = habit.size / 5;
        const x = centerX + Math.cos(angle * (Math.PI / 180)) * (habit.size + offset);
        const y = centerY + Math.sin(angle * (Math.PI / 180)) * (habit.size + offset);

        const outerCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        outerCircle.setAttribute('cx', x);
        outerCircle.setAttribute('cy', y);
        outerCircle.setAttribute('r', outerRadius);
        outerCircle.setAttribute('fill', habit.color);
        container.appendChild(outerCircle);

        const innerCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        innerCircle.setAttribute('cx', x);
        innerCircle.setAttribute('cy', y);
        innerCircle.setAttribute('r', innerRadius);
        innerCircle.setAttribute('fill', '#ffffff');  // White or transparent to create the torus effect
        container.appendChild(innerCircle);
    }
};

export const dodecahedronRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const size = habit.size / 5;
        const x = centerX + Math.cos(angle * (Math.PI / 180)) * (habit.size + offset);
        const y = centerY + Math.sin(angle * (Math.PI / 180)) * (habit.size + offset);

        const dodecahedron = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
        let points = [];
        for (let j = 0; j < 12; j++) {
            const pointX = x + size * Math.cos((j * 360 / 12) * (Math.PI / 180));
            const pointY = y + size * Math.sin((j * 360 / 12) * (Math.PI / 180));
            points.push(`${pointX},${pointY}`);
        }

        dodecahedron.setAttribute('points', points.join(' '));
        dodecahedron.setAttribute('fill', habit.color);
        container.appendChild(dodecahedron);
    }
};

export const segmentRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const radius = habit.size / 10;  // Make radius smaller for smaller segments
        const startAngle = angle;
        const endAngle = angle + 30;  // Decrease the span of the segment for smaller size

        // Calculate the points for the arc
        const x1 = centerX + Math.cos(startAngle * (Math.PI / 180)) * (radius + offset);
        const y1 = centerY + Math.sin(startAngle * (Math.PI / 180)) * (radius + offset);
        const x2 = centerX + Math.cos(endAngle * (Math.PI / 180)) * (radius + offset);
        const y2 = centerY + Math.sin(endAngle * (Math.PI / 180)) * (radius + offset);

        const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';

        const segmentPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        const pathData = [
            `M ${centerX} ${centerY}`, // Move to center
            `L ${x1} ${y1}`,           // Line to first point
            `A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2}`, // Arc to second point
            'Z'                        // Close the path
        ].join(' ');

        segmentPath.setAttribute('d', pathData);
        segmentPath.setAttribute('fill', habit.color);
        container.appendChild(segmentPath);
    }
};

export const heptagonRenderer = (habit, centerX, centerY, offset, container) => {
    for (let i = 0; i < habit.count; i++) {
        const angle = (360 / habit.count) * i;
        const size = habit.size / 5;
        const x = centerX + Math.cos(angle * (Math.PI / 180)) * (habit.size + offset);
        const y = centerY + Math.sin(angle * (Math.PI / 180)) * (habit.size + offset);

        const heptagon = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
        let points = [];
        for (let j = 0; j < 7; j++) {
            const pointX = x + size * Math.cos((j * 360 / 7) * (Math.PI / 180));
            const pointY = y + size * Math.sin((j * 360 / 7) * (Math.PI / 180));
            points.push(`${pointX},${pointY}`);
        }

        heptagon.setAttribute('points', points.join(' '));
        heptagon.setAttribute('fill', habit.color);
        container.appendChild(heptagon);
    }
};

export const shapeRenderers = {
    circle: circleRenderer,
    square: squareRenderer,
    triangle: triangleRenderer,
    hexagon: hexagonRenderer,
    pentagon: pentagonRenderer,
    octagon: octagonRenderer,
    star: starRenderer,
    rectangle: rectangleRenderer,
    ellipse: ellipseRenderer,
    parallelogram: parallelogramRenderer,
    crescent: crescentRenderer,
    petal: petalRenderer,
    oval: ovalRenderer,
    rhombus: rhombusRenderer,
    trapezoid: trapezoidRenderer,
    heptagon: heptagonRenderer,
    tetrahedron: tetrahedronRenderer,
    pyramid: pyramidRenderer,
    sphere: sphereRenderer,
    cube: cubeRenderer,
    cone: coneRenderer,
    cylinder: cylinderRenderer,
    torus: torusRenderer,
    dodecahedron: dodecahedronRenderer,
    segment: segmentRenderer,
};

export const drawShape = async (habit, centerX, centerY, offset, container) => {
    const renderer = shapeRenderers[habit.icon.toLowerCase()];
    if (renderer) {
        // Call the renderer if it exists in shapeRenderers
        renderer(habit, centerX, centerY, offset, container);
    } else {
        // If not found, try to dynamically fetch a new renderer from AI
        const aiRenderer = await requestShapeFromAI(habit.icon);
        if (aiRenderer) {
            aiRenderer(habit, centerX, centerY, offset, container);
        }
    }
};

export const renderHabits = async (habitData, container) => {
    // Clear any previous elements before rendering new ones
    while (container.firstChild) {
        container.removeChild(container.firstChild);  // This is more appropriate for SVG elements
    }
    habitData.forEach(async (habit, index) => {
        const centerX = 300;
        const centerY = 300;
        const offset = index * 20;  // Add a bit of offset to space out the patterns
        await drawShape(habit, centerX, centerY, offset, container);
    });
};
